import usePrivateAxios from '@/common/api/usePrivateAxios';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { DashboardComponentData, DashboardComponentFiltersParamsParsed, DashboardComponentResponse } from '../../types/dashboards/dashboardComponent.type';

type UseDashboardComponentProps = {
  dashboardComponentId: string | undefined;
  filters?: DashboardComponentFiltersParamsParsed;
}

type UseDashboardComponentType = (props: UseDashboardComponentProps) => UseQueryResult<DashboardComponentData, unknown>;

export const useDashboardComponent: UseDashboardComponentType = ({
  dashboardComponentId,
  filters,
}) => {
  const privateAxios = usePrivateAxios();

  return useQuery<DashboardComponentResponse, unknown, DashboardComponentData>({
    enabled: !!dashboardComponentId,
    queryKey: [
      'dashboardComponent', dashboardComponentId,
      ...[filters ?? {}],
    ],
    queryFn: () => privateAxios.get(`/dashboard_components/${dashboardComponentId}`, {
      params: {
        q: {
          ...filters,
        }
      },
    }),
    select: (data) => data?.data?.data,
  });
}
